import { tv } from 'tailwind-variants'

export const gridItemVariants = tv({
  base: 'relative flex items-center justify-center p-2',
  variants: {
    hasRightBorder: {
      true: 'border-r border-white/10',
      false: ''
    },
    hasBottomBorder: {
      true: 'border-b border-white/10',
      false: ''
    },
    isGroup: {
      true: 'group',
      false: ''
    }
  },
  defaultVariants: {
    hasRightBorder: false,
    hasBottomBorder: false,
    isGroup: false
  }
})